<aside  
    id="large-sidebar" 
    class="sidebar fixed top-0 left-0 z-20 w-88 text-lg h-screen"
    [ngClass]="{ '-translate-x-full duration-700': sidebarStatus === 'small' }" 
    aria-label="Sidebar"
>
    <div class="sidebar-scroll h-minus-4 ml-4 shadow-custom-1 rounded-b-lg p-1 overflow-y-auto bg-white border-r border-gray-300">
        <div id="large-sidebar-content">
            <div class="py-6">
                <ul class="space-y-2">
                    <li *ngFor="let entry of sidebarEntries; trackBy: trackByEntry" class="group">
                        <button
                            *ngIf="entry.route; else largeGroupEntry"
                            (click)="$event.preventDefault(); navigateEntry(entry)"
                            class="flex items-center w-full p-2 rounded-md hover:text-nside-orange-400 cursor-pointer"
                            [ngClass]="{ 'text-nside-orange-400': isEntryActive(entry) }"
                        >
                            <div class="w-6 flex items-center justify-center">
                                <lucide-icon [name]="icons[entry.icon]" [size]="20"></lucide-icon>
                            </div>
                            <span class="oswald-font flex-1 ms-1 text-left whitespace-nowrap">
                                {{ entry.title }}
                            </span>
                        </button>
                        <ng-template #largeGroupEntry>
                            <div
                                class="flex items-center w-full p-2 rounded-md group-hover:text-nside-orange-400 cursor-pointer"
                                [ngClass]="{ 'text-nside-orange-400': isEntryActive(entry) }"
                            >
                                <div class="w-6 flex items-center justify-center">
                                    <lucide-icon [name]="icons[entry.icon]" [size]="20"></lucide-icon>
                                </div>
                                <span class="oswald-font flex-1 ms-1 text-left whitespace-nowrap">
                                    {{ entry.title }}
                                </span>
                            </div>
                            <ul
                                *ngIf="entry.children?.length"
                                [attr.id]="getDropdownId(entry)"
                                class="sidebar-flyout hidden oswald-font text-base p-2 bg-gray-100 rounded-md border border-gray-300 shadow-custom-2 space-y-1 group-hover:block"
                            >
                                <li *ngFor="let item of entry.children; trackBy: trackByItem">
                                    <button
                                        (click)="$event.preventDefault(); navigateToPage(item.route)"
                                        class="flex items-center w-full px-2 py-1 text-left transition duration-75 rounded hover:bg-gray-300 cursor-pointer"
                                        [ngClass]="{ 'bg-gray-300': isItemActive(item) }"
                                    >
                                        {{ item.title }}
                                    </button>
                                </li>
                            </ul>
                        </ng-template>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div 
        id="toggle-btn" 
        class="absolute top-6 -right-6 py-3 bg-white border-r border-gray-300 cursor-pointer shadow-custom-1"
        (click)="$event.preventDefault(); toggleSidebar();"
    >
        <lucide-icon [img]="icons.ChevronLeft"></lucide-icon>
    </div>
</aside>
